import addDays from 'date-fns/addDays/index.js'
import format from 'date-fns/format/index.js'
import differenceInDays from 'date-fns/differenceInDays/index.js'

import parseISO from 'date-fns/parseISO/index.js'

export function getDescription(value) {
  //one of the connections might be expiring
  if (!value.app.connection?.expiresInDays || !value.connected_at) {
    return `The connection should be reconnected.`
  }

  let expiresDate = addDays(
    parseISO(value.connected_at),
    value.app.connection.expiresInDays
  )

  let formattedExpiresDate = format(expiresDate, 'MMM d, yyyy, h:mm aaa')
  let expiresDays = differenceInDays(expiresDate, new Date())

  if (value.status === 'expired' || expiresDays < 1)
    return `The connection ${
      value.display_name || ''
    } expired on ${formattedExpiresDate}. It should be reconnected.`

  return `The connection to ${
    value.display_name
  } will reset in ${differenceInDays(
    expiresDate,
    new Date()
  )} days on ${formattedExpiresDate}.`
}
